type MindboxFn = {
  (...args: unknown[]): void;
  queue: unknown[][];
};

declare global {
  interface Window {
    mindbox?: MindboxFn;
    PopMechanic?: {
      watchLocation?: boolean;
      update?: () => void;
    };
  }
}

// единый Domain API для всех энвайроментов;
const MINDBOX_DOMAIN = 'api.s.mindbox.ru';

const TRACKER_URL = `https://${MINDBOX_DOMAIN}/scripts/v1/tracker.js`;

/**
 * Инициализация Mindbox JS SDK.
 */
export const buildMindboxInitCode = () => `
window.PopMechanic = window.PopMechanic || { watchLocation: false };
window.mindbox = window.mindbox || function () { window.mindbox.queue.push(arguments); };
window.mindbox.queue = window.mindbox.queue || [];
window.mindbox('create');
var _mindboxScript = document.createElement('script');
_mindboxScript.type = 'text/javascript';
_mindboxScript.async = true;
_mindboxScript.src = '${TRACKER_URL}';
document.head.appendChild(_mindboxScript);
`;

/**
 * source of truth для включения/выключения флага MINDBOX_ENABLE.
 */
export const isMindboxEnabled = (value?: boolean | string) =>
  value === true || value === '1' || value === 'true';

const isMindboxDebug =
  process.env.NODE_ENV === 'development' &&
  (process.env.MINDBOX_DEBUG === 'true' || process.env.MINDBOX_DEBUG === '1');

const logDevError = (operation: string, data: unknown, err: unknown) => {
  if (isMindboxDebug) {
    console.log(`Mindbox operation fired: '${operation}'`);
    if (data && Object.keys(data as Record<string, unknown>).length) console.log('data:', data);
    console.log('\n');
  }
  console.warn('Something went wrong with Mindbox: ', err);
};

export type MindboxAsyncOperation = {
  operation: string;
  data?: Record<string, unknown>;
  onSuccess?: (response: unknown) => void;
  onError?: (error: unknown) => void;
};

export type MindboxSyncOperation = {
  operation: string;
  data?: Record<string, unknown>;
  onSuccess?: (response: unknown) => void;
  onValidationError?: (validationMessages: unknown[]) => void;
  onError?: (error: unknown) => void;
};

export function sendAsyncOperation({ operation, data, onSuccess, onError }: MindboxAsyncOperation) {
  try {
    window.mindbox?.('async', { operation, data, onSuccess, onError });
  } catch (err) {
    logDevError(operation, data, err);
  }
}

export function sendSyncOperation({
  operation,
  data,
  onSuccess,
  onValidationError,
  onError,
}: MindboxSyncOperation) {
  try {
    window.mindbox?.('sync', { operation, data, onSuccess, onValidationError, onError });
  } catch (err) {
    logDevError(operation, data, err);
  }
}

export function getDeviceUUID(callback: (deviceUUID: string) => void) {
  try {
    window.mindbox?.('helpers.getDeviceUUID', callback);
  } catch (err) {
    logDevError('helpers.getDeviceUUID', undefined, err);
  }
}

/**
 * Обновляет механики Mindbox после смены маршрута на стороне клиента.
 *
 * Note: для всех действий зависящих от товара, категории или корзины,
 * необходимо выполнить соответствующую операцию перед вызовом этого метода  («просмотр товара» или «обновление корзины»).
 */
export function updatePopMechanic() {
  try {
    window.PopMechanic?.update?.();
  } catch (err) {
    logDevError('PopMechanic.update', undefined, err);
  }
}
